var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-tabs",
        {
          attrs: { color: "transparent", "show-arrows": "" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("v-tabs-slider", { attrs: { color: "primary" } }),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { "align-center": "", "justify-space-between": "" } },
            [
              _c(
                "span",
                _vm._l(_vm.tabs, function(tabItem) {
                  return _c("v-tab", { key: tabItem }, [
                    _vm._v("\n          " + _vm._s(tabItem) + "\n        ")
                  ])
                }),
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "v-tabs-items",
            {
              attrs: { touchless: "" },
              model: {
                value: _vm.tab,
                callback: function($$v) {
                  _vm.tab = $$v
                },
                expression: "tab"
              }
            },
            [
              _c(
                "v-tab-item",
                [
                  !_vm.isAdmin
                    ? _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs3: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { dark: "", color: "primary" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.showEditEeiDialog()
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", { attrs: { dark: "" } }, [
                                    _vm._v("add")
                                  ]),
                                  _vm._v(_vm._s(_vm.$t("eei")))
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            [
                              _c("v-icon", [_vm._v("info")]),
                              _vm._v(" " + _vm._s(_vm.$t("eeiInfo")))
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("PaginationController", {
                    attrs: {
                      getDataActionName: "getEeiPagination",
                      historyLimit: _vm.historyLimit,
                      searchBoxLabel: _vm.$t("search"),
                      searchBoxHint: _vm.$t("eeiSearchBoxHint"),
                      select: _vm.isAdmin
                        ? (_vm.selectedBalanceTable || {}).clientKey
                        : null,
                      haveSearchBox: "",
                      haveStartDate: ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "dataTable",
                        fn: function() {
                          return [
                            _c("v-data-table", {
                              attrs: {
                                headers: _vm.headers,
                                items: _vm.eeiHistory,
                                "hide-actions": "",
                                "item-key": "_key",
                                "select-all": "blue"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "items",
                                  fn: function(props) {
                                    return [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "checkbox-align-center",
                                          on: {
                                            click: function($event) {
                                              props.item.url &&
                                                props.item.status !==
                                                  "canceled" &&
                                                (props.selected = !props.selected)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-layout",
                                            [
                                              _c("v-checkbox", {
                                                attrs: {
                                                  disabled:
                                                    !props.item.url ||
                                                    props.item.status ===
                                                      "canceled",
                                                  value: props.selected,
                                                  primary: "",
                                                  "hide-details": ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return function() {
                                                      props.selected = !props.selected
                                                    }.apply(null, arguments)
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-left" },
                                        [
                                          _c("v-layout", [
                                            _c("strong", [_vm._v("ID: ")]),
                                            _vm._v(
                                              _vm._s(props.item.requestId) +
                                                "\n                  "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          props.item.clientName && _vm.isAdmin
                                            ? _c(
                                                "v-layout",
                                                { attrs: { wrap: "" } },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "font-weight-bold"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("client")
                                                        ) + ":  "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    _vm._s(
                                                      props.item.clientName
                                                    ) + "\n                  "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm._l(
                                            props.item.commodities,
                                            function(commodity, index) {
                                              return _c(
                                                "v-layout",
                                                {
                                                  key: index,
                                                  attrs: {
                                                    "justify-space-between": ""
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    { attrs: { xs7: "" } },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            commodity.profileName
                                                          ) +
                                                          " （" +
                                                          _vm._s(
                                                            commodity.scheduleBCode
                                                          ) +
                                                          "）\n                    "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-flex",
                                                    { attrs: { xs3: "" } },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            commodity.quantity
                                                          ) +
                                                          "\n                    "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            }
                                          )
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-left" },
                                        [
                                          _c("LabelAddressWidget", {
                                            attrs: { address: props.item.from }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-left" },
                                        [
                                          _c("LabelAddressWidget", {
                                            attrs: { address: props.item.to }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-left" },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                props.item.status === "rejected"
                                                  ? props.item.message
                                                  : props.item.itn
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.$store.getters.activeWarehouse
                                        ? _c(
                                            "td",
                                            { staticClass: "text-xs-left" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.organizationKeyToId.get(
                                                      props.item.clientKey
                                                    )
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-left" },
                                        [
                                          _c("v-layout", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.toDateYYYYMMDDHHmm(
                                                    props.item.createTime
                                                  )
                                                ) +
                                                "\n                  "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("v-layout", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(props.item.onboardDate) +
                                                "\n                  "
                                            )
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-left" },
                                        [
                                          _c(
                                            "v-layout",
                                            [
                                              props.item.status === "error"
                                                ? _c(
                                                    "v-flex",
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: { top: "" },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key:
                                                                  "activator",
                                                                fn: function(
                                                                  tooltip
                                                                ) {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      _vm._g(
                                                                        {},
                                                                        tooltip.on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "partial_highlight"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                              " +
                                                                                _vm._s(
                                                                                  props
                                                                                    .item
                                                                                    .status ||
                                                                                    "pending"
                                                                                ) +
                                                                                "\n                            "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                }
                                                              }
                                                            ],
                                                            null,
                                                            true
                                                          )
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                props.item
                                                                  .message
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _c("v-flex", [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          props.item.status ||
                                                            "pending"
                                                        ) +
                                                        "\n                    "
                                                    )
                                                  ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          class: props.item.totalAmount
                                            ? "text-xs-left fontRed"
                                            : props.item.amount > 0
                                            ? "text-xs-left fontGreen"
                                            : "text-xs-left fontRed"
                                        },
                                        [
                                          _vm._v(
                                            "\n                  $" +
                                              _vm._s(
                                                -props.item.totalAmount ||
                                                  props.item.amount ||
                                                  0
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-xs-left" },
                                        [
                                          _c(
                                            "v-layout",
                                            [
                                              !props.item.status ||
                                              props.item.status === "pending"
                                                ? _c(
                                                    "v-flex",
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: { top: "" },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key:
                                                                  "activator",
                                                                fn: function(
                                                                  tooltip
                                                                ) {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      _vm._g(
                                                                        {},
                                                                        tooltip.on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "LoaderButton",
                                                                          {
                                                                            attrs: {
                                                                              buttonIcon:
                                                                                "refresh",
                                                                              flat:
                                                                                "",
                                                                              promiseAwait:
                                                                                _vm.getEeiStatus,
                                                                              promiseItem:
                                                                                props.item
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ]
                                                                }
                                                              }
                                                            ],
                                                            null,
                                                            true
                                                          )
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "getStatus"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : !_vm.isAdmin
                                                ? _c(
                                                    "v-flex",
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: { top: "" },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key:
                                                                  "activator",
                                                                fn: function(
                                                                  tooltip
                                                                ) {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      _vm._g(
                                                                        {},
                                                                        tooltip.on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "v-btn",
                                                                          {
                                                                            attrs: {
                                                                              icon:
                                                                                "",
                                                                              color:
                                                                                "primary",
                                                                              flat:
                                                                                ""
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                e
                                                                              ) {
                                                                                return props
                                                                                  .item
                                                                                  .status ===
                                                                                  "canceled"
                                                                                  ? _vm.showRecreateEeiDialog(
                                                                                      props.item
                                                                                    )
                                                                                  : _vm.showEditEeiDialog(
                                                                                      props.item
                                                                                    )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            props
                                                                              .item
                                                                              .status ===
                                                                            "canceled"
                                                                              ? _c(
                                                                                  "v-icon",
                                                                                  [
                                                                                    _vm._v(
                                                                                      "content_copy"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : _c(
                                                                                  "v-icon",
                                                                                  [
                                                                                    _vm._v(
                                                                                      "edit"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                          ],
                                                                          1
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ]
                                                                }
                                                              }
                                                            ],
                                                            null,
                                                            true
                                                          )
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                props.item
                                                                  .status ===
                                                                  "canceled"
                                                                  ? _vm.$t(
                                                                      "copy"
                                                                    ) + " EEI"
                                                                  : _vm.$t(
                                                                      "update"
                                                                    ) + " EEI"
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              props.item.status === "ready"
                                                ? _c(
                                                    "v-flex",
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: { top: "" },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key:
                                                                  "activator",
                                                                fn: function(
                                                                  tooltip
                                                                ) {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      _vm._g(
                                                                        {},
                                                                        tooltip.on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "v-btn",
                                                                          {
                                                                            attrs: {
                                                                              icon:
                                                                                "",
                                                                              color:
                                                                                "primary",
                                                                              flat:
                                                                                ""
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                e
                                                                              ) {
                                                                                return _vm.showCreateInternationalLabelPopup(
                                                                                  props.item
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-icon",
                                                                              [
                                                                                _vm._v(
                                                                                  "shopping_cart"
                                                                                )
                                                                              ]
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ]
                                                                }
                                                              }
                                                            ],
                                                            null,
                                                            true
                                                          )
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "createInternationalLabel"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !["canceled", "pending"].includes(
                                                props.item.status
                                              )
                                                ? _c(
                                                    "v-flex",
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: { top: "" },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key:
                                                                  "activator",
                                                                fn: function(
                                                                  tooltip
                                                                ) {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      _vm._g(
                                                                        {},
                                                                        tooltip.on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "LoaderButton",
                                                                          {
                                                                            attrs: {
                                                                              buttonIcon:
                                                                                "delete",
                                                                              flat:
                                                                                "",
                                                                              promiseAwait:
                                                                                _vm.cancelEei,
                                                                              promiseItem:
                                                                                props.item
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ]
                                                                }
                                                              }
                                                            ],
                                                            null,
                                                            true
                                                          )
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.$t("cancel")
                                                              ) +
                                                              " EEI\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ]),
                              model: {
                                value: _vm.selectedEei,
                                callback: function($$v) {
                                  _vm.selectedEei = $$v
                                },
                                expression: "selectedEei"
                              }
                            })
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "beforeMenu",
                        fn: function() {
                          return [
                            _vm.isAdmin
                              ? _c(
                                  "v-layout",
                                  {
                                    attrs: {
                                      row: "",
                                      wrap: "",
                                      "justify-space-between": ""
                                    }
                                  },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { md6: "" } },
                                      [
                                        _c("v-autocomplete", {
                                          attrs: {
                                            label: _vm.$t("selectOrg"),
                                            "return-object": "",
                                            "item-text": "clientName",
                                            items: _vm.balances,
                                            clearable: ""
                                          },
                                          model: {
                                            value: _vm.selectedBalanceTable,
                                            callback: function($$v) {
                                              _vm.selectedBalanceTable = $$v
                                            },
                                            expression: "selectedBalanceTable"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        },
                        proxy: true
                      }
                    ]),
                    model: {
                      value: _vm.eeiHistory,
                      callback: function($$v) {
                        _vm.eeiHistory = $$v
                      },
                      expression: "eeiHistory"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.eeiDialog
        ? _c("EeiEditPopup", {
            attrs: { eeiInEdit: _vm.eeiInEdit, isRecreate: _vm.isRecreate },
            on: { submitted: _vm.onProcessEei },
            model: {
              value: _vm.eeiDialog,
              callback: function($$v) {
                _vm.eeiDialog = $$v
              },
              expression: "eeiDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowCreateInternationalLabelPopup
        ? _c("LabelCreateInternationalPopup", {
            attrs: {
              idGenerator: _vm.labelIdGenerator,
              labelInfo: _vm.labelInfo
            },
            model: {
              value: _vm.isShowCreateInternationalLabelPopup,
              callback: function($$v) {
                _vm.isShowCreateInternationalLabelPopup = $$v
              },
              expression: "isShowCreateInternationalLabelPopup"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e098bd6e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e098bd6e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Eei.vue
// module id = null
// module chunks = 